export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGINOROUT_FAILURE = 'LOGINOROUT_FAILURE';
export const DEREGISTER_LOGIN_USER = 'DEREGISTER_LOGIN_USER'; // 注销当前用户



// WEBPACK FOOTER //
// ./src/views/LoginForm/flow/actionTypes.js